import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CORES } from '../theme';

/**
 * Diálogo de confirmação único para o sistema.
 * - "Cancelar" é neutro e recebe o foco (evita exclusão acidental com Enter).
 * - A ação destrutiva fica em vermelho e diz o que faz ("Excluir").
 */
const ConfirmDialog = ({
    open,
    setOpen,
    onConfirm,
    title = 'Confirmar exclusão',
    children = 'Esta ação não pode ser desfeita.',
    confirmLabel = 'Excluir',
    cancelLabel = 'Cancelar',
    destrutivo = true,
}) => {
    const fechar = () => setOpen(false);

    return (
        <Dialog open={open} onClose={fechar} aria-labelledby="confirm-dialog-titulo" maxWidth="xs" fullWidth>
            <DialogTitle id="confirm-dialog-titulo">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText component="div">{children}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={fechar} autoFocus>
                    {cancelLabel}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    style={destrutivo ? { backgroundColor: CORES.erro, color: '#fff' } : undefined}
                    onClick={() => {
                        fechar();
                        onConfirm();
                    }}
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
